import styled, { css, keyframes } from 'styled-components'
import { pxToRem } from 'styles/functions'

const topBubbles = keyframes`
  0% {
    background-position: 5% 90%, 10% 90%, 10% 90%, 15% 90%, 25% 90%, 25% 90%, 40% 90%, 55% 90%, 70% 90%;
  }
  50% {
    background-position: 0 80%, 0 20%, 10% 40%, 20% 0, 30% 30%, 22% 50%, 50% 50%, 65% 20%, 90% 30%;
  }
  100% {
    background-position: 0 70%, 0 10%, 10% 30%, 20% -10%, 30% 20%, 22% 40%, 50% 40%, 65% 10%, 90% 20%;
    background-size: 0 0, 0 0, 0 0, 0 0, 0 0, 0 0;
  }
`

const bottomBubbles = keyframes`
  0% {
    background-position: 10% -10%, 30% 10%, 55% -10%, 70% -10%, 85% -10%, 70% -10%, 70% 0;
  }
  50% {
    background-position: 0 80%, 20% 80%, 45% 60%, 60% 100%, 75% 70%, 95% 60%, 105% 0;
  }
  100% {
    background-position: 0 90%, 20% 90%, 45% 70%, 60% 110%, 75% 80%, 95% 70%, 110% 10%;
    background-size: 0 0, 0 0, 0 0, 0 0, 0 0, 0 0;
  }
`

export const SCBottomBarContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(${pxToRem(80)} + env(safe-area-inset-bottom, 0px));
  background: rgba(35, 35, 35, 0.75);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: calc(10px + env(safe-area-inset-bottom, 0px));
  z-index: 10;

  @media (min-width: 768px) and (orientation: landscape) {
    top: 0;
    right: 0;
    bottom: unset;
    left: unset;
    width: ${pxToRem(91)};
    height: 100%;
    flex-direction: column;
    justify-content: stretch;
    align-items: stretch;
    padding-bottom: 0;
    padding: 0;
  }
`

export const SCButtonsRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  width: 100%;

  @media (min-width: 768px) and (orientation: landscape) {
    flex-direction: column;
    justify-content: space-around;
    align-items: stretch;
    height: 100%;
    width: 100%;
  }
`

export const SCButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  @media (min-width: 768px) and (orientation: landscape) {
    flex-direction: column;
    align-items: center;
    padding: ${pxToRem(6)} ${pxToRem(4)};
    cursor: pointer;
  }
`

interface SCButtonCircleProps {
  $size?: 'large' | 'xlarge';
  $variant?: 'default' | 'info';
}
export const SCButtonCircle = styled.div<SCButtonCircleProps>`
  ${({ $size }) => {
    switch ($size) {
      case 'xlarge':
        return css`
          width: ${pxToRem(90)};
          height: ${pxToRem(90)};
          background-color: ${({ theme }) =>
            theme.photobooth_button_color || theme.button_color || '#34b076'};
        `
      default:
        return css`
          width: ${pxToRem(70)};
          height: ${pxToRem(70)};
          background-color: #232323;
        `
    }
  }}

  border-radius: ${({ $variant }) => ($variant === 'info' ? '50% 50% 0 50%' : '50%')};
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${pxToRem(2)} ${pxToRem(5)} ${pxToRem(10)} rgba(0, 0, 0, 0.7);

  @media (min-width: 768px) and (orientation: landscape) {
    width: ${({ $size }) => ($size === 'xlarge' ? `${pxToRem(65)}` : `${pxToRem(45)}`)};
    height: ${({ $size }) => ($size === 'xlarge' ? `${pxToRem(65)}` : `${pxToRem(45)}`)};
    padding-top: 0;
    flex-shrink: 0;
    box-shadow: none;

    svg {
      width: ${pxToRem(35)};
      height: ${pxToRem(35)};
    }
  }

  &:before,
  &:after {
    position: absolute;
    content: '';
    display: block;
    width: 140%;
    height: 100%;
    left: -20%;
    z-index: -1000;
    transition: all ease-in-out 0.5s;
    background-repeat: no-repeat;
  }

  &:before {
    display: none;
    top: -75%;
    background-image: radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        transparent 20%,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 30%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        transparent 10%,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 15%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      );
    background-size:
      10% 10%,
      20% 20%,
      15% 15%,
      20% 20%,
      18% 18%,
      10% 10%,
      15% 15%,
      10% 10%,
      18% 18%;
  }

  &:after {
    display: none;
    bottom: -75%;
    background-image: radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        transparent 10%,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 15%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      );
    background-size:
      15% 15%,
      20% 20%,
      18% 18%,
      20% 20%,
      15% 15%,
      10% 10%,
      20% 20%;
  }

  &.animate:before {
    display: block;
    animation: ${topBubbles} ease-in-out 0.75s forwards;
  }

  &.animate:after {
    display: block;
    animation: ${bottomBubbles} ease-in-out 0.75s forwards;
  }
`

interface SCButtonIconProps {
  $size?: 'xlarge'|'large';
}
export const SCButtonIcon = styled.img<SCButtonIconProps>`
  width: ${({ $size }) => ($size === 'xlarge' ? `${pxToRem(65)}` : `${pxToRem(40)}`)};
  height: ${({ $size }) => ($size === 'xlarge' ? `${pxToRem(65)}` : `${pxToRem(40)}`)};
  color: white;

  @media (min-width: 768px) and (orientation: landscape) {
    width: ${({ $size }) => ($size === 'xlarge' ? `${pxToRem(45)}` : `${pxToRem(35)}`)};
    height: ${({ $size }) => ($size === 'xlarge' ? `${pxToRem(45)}` : `${pxToRem(35)}`)};
    margin-left: 0;
  }
`

export const SCButtonLabel = styled.span`
  font-size: ${pxToRem(12)};
  color: white;
  text-align: center;
  margin-bottom: ${pxToRem(20)};
  margin-top: ${pxToRem(5)};
  font-weight: 600;
  z-index: 1;
  font-family: ${({ theme }) => theme.title_font || `'Nunito', sans-serif`};

  @media (min-width: 768px) and (orientation: landscape) {
    margin-bottom: 0;
    margin-top: ${pxToRem(4)};
    font-size: ${pxToRem(14)};
  }
`